import React from "react";
import { Box } from "@mui/material";
import { CustomSectionTitle } from "@ippon/shared-components";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import PrivateAreaCreateForm from "@/components/PropertyDetail/PrivateArea/CreateForm";

/**
 * 専有部登録ページ。
 *
 * NOTE:
 *   - 物件詳細 > 物件構成 > 専有部 一覧から開く場合はモーダル
 *     （`PrivateAreaCreateModal`）に切り替えたため、本ページは
 *     直接 URL アクセスや旧導線の互換用としてのみ機能する。
 *   - 実装本体は `components/PropertyDetail/PrivateArea/CreateForm` に集約済み。
 */
const PrivateAreaCreatePage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams<{ propertyId: string }>();

  const propertyName = (location.state as any)?.propertyName || "";

  return (
    <Box pb={{ xs: 2, md: 10 }} pt={{ xs: 2, sm: 3 }}>
      <CustomSectionTitle
        title="専有部登録"
        size="large"
        sx={{ mb: 4 }}
        addBorder={false}
      />
      <PrivateAreaCreateForm
        mode="page"
        propertyId={params.propertyId || ""}
        propertyName={propertyName}
        onSuccess={(createdId, createdName) => {
          if (createdId) {
            navigate(
              `/properties/${params.propertyId}/private-area/${createdId}`,
              {
                replace: true,
                state: {
                  propertyName: propertyName,
                  privateAreaName: createdName,
                },
              },
            );
            window.scrollTo({ top: 0 });
          } else {
            navigate(`/properties/${params.propertyId}`);
          }
        }}
        onCancel={() =>
          navigate(`/properties/${params.propertyId}?tab=0`)
        }
      />
    </Box>
  );
};

export default PrivateAreaCreatePage;
